import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "pl-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "flex xs1 pt-3",
  style: {"text-align":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "@", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "row pt-3"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Subscriptions ")

import { Group } from "@/models/Group";
import { Subscription } from "@/models/Subscription";
import { computed, ref } from "vue";
import { GroupFrequency } from "@/notifi_types";
import draggable from "vuedraggable";
import { UserChannel } from "@/models/Channel";
import SubscriptionListItem from "@/components/SubscriptionListItem.vue";
import ChannelPicker from "@/components/ChannelPicker.vue";

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  props: {
  group: { type: Group, required: true },
  showSubscriptions: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props



const activeGroup = ref<Group>(props.group);
const subscriptions = ref<Subscription[]>([]);

const newGroup = computed(() => activeGroup.value.id == undefined);

const valid = computed((): boolean => {
  return (
    name.value != undefined &&
    name.value.length > 3 &&
    validFrequencySetting.value &&
    userChannel.value != undefined
  );
});

const validFrequencySetting = computed((): boolean => {
  return (
    (frequency.value != undefined &&
      frequency.value == GroupFrequency.realtime) ||
    (frequency.value == GroupFrequency.daily && alertTime.value != undefined) ||
    (frequency.value == GroupFrequency.weekly &&
      alertTime.value != undefined &&
      alertDay.value != undefined)
  );
});

const saveNew = async (): Promise<Group> => {
  return await activeGroup.value.save();
};

const fetchSubscriptions = async () => {
  subscriptions.value.length = 0;
  subscriptions.value.push(...(await props.group.subscriptions()));
};

if (props.showSubscriptions && !newGroup.value) {
  fetchSubscriptions();
}

const name = computed({
  get: () => activeGroup.value?.name,
  set: (value) => {
    activeGroup.value.name = value;
    if (!newGroup.value) {
      activeGroup.value.save();
    }
  },
});

const description = computed({
  get: () => activeGroup.value?.description,
  set: (value) => {
    activeGroup.value.description = value;
    if (!newGroup.value) {
      activeGroup.value.save();
    }
  },
});

const frequency = computed({
  get: () => activeGroup.value?.frequency,
  set: (value) => {
    activeGroup.value.frequency = value;
    if (!newGroup.value) {
      activeGroup.value.save();
    }
  },
});

const alertDay = computed({
  get: () => activeGroup.value?.alertDay,
  set: (value) => {
    activeGroup.value.alertDay = value;
    if (!newGroup.value) {
      activeGroup.value.save();
    }
  },
});

const alertTime = computed({
  get: () => {
    let db = activeGroup.value.alertTime;
    if (!db) db = "8:00 AM ";
    const d = new Date(`Jan 1, 1900 ${db}`);
    return d;
  },
  set: (value: Date) => {
    activeGroup.value.alertTime = value.toTimeString();
    if (!newGroup.value) {
      activeGroup.value.save();
    }
  },
});

const userChannel = computed({
  get: () => {
    return activeGroup.value.userChannel;
  },
  set: (value: UserChannel) => {
    activeGroup.value.userChannel = value;
    if (!newGroup.value) {
      activeGroup.value.save();
    }
  },
});

const minFilter = (m: number) => {
  console.log(m);
  return m == 0 || m == 30;
};

const alertDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const pickTime = computed(() => {
  return frequency.value != GroupFrequency.realtime;
});

const pickDay = computed(() => {
  return frequency.value == GroupFrequency.weekly;
});

const frequencyOptions = Object.values(GroupFrequency);

const subListVisible = ref(false);
const toggleSubList = () => {
  subListVisible.value = !subListVisible.value;
};
const subListIconName = computed(() => {
  return subListVisible.value ? "expand_more" : "expand_less";
});

const checkMove = (event: any) => {
  return false;
};

const dragChange = async (event: any) => {
  if (event.added) {
    event.added.element.group = activeGroup.value;
    event.added.element.save();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_radio = _resolveComponent("va-radio")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_time_input = _resolveComponent("va-time-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_VaIcon = _resolveComponent("VaIcon")!
  const _component_va_list = _resolveComponent("va-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_va_input, {
        label: "Name",
        modelValue: _unref(name),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
        class: "flex xs12 md6"
      }, null, 8, ["modelValue"]),
      _createVNode(ChannelPicker, {
        class: "flex xs12 md6",
        label: "Email",
        modelValue: _unref(userChannel),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(userChannel) ? (userChannel).value = $event : null)),
        emailOnly: true
      }, null, 8, ["modelValue"]),
      _createVNode(_component_va_input, {
        label: "Description",
        modelValue: _unref(description),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
        class: "flex xs12 lg12"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(frequencyOptions), (option) => {
          return (_openBlock(), _createBlock(_component_va_radio, {
            key: option,
            modelValue: _unref(frequency),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(frequency) ? (frequency).value = $event : null)),
            option: option
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(option), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "option"]))
        }), 128)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createVNode(_component_va_select, {
            class: "flex xs6 sm6 lg5",
            options: alertDays,
            label: "Alert Day",
            modelValue: _unref(alertDay),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(alertDay) ? (alertDay).value = $event : null))
          }, null, 8, ["modelValue"]), [
            [_vShow, _unref(pickDay)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
            [_vShow, _unref(pickDay) || _unref(pickTime)]
          ]),
          _withDirectives(_createVNode(_component_va_time_input, {
            modelValue: _unref(alertTime),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(alertTime) ? (alertTime).value = $event : null)),
            minutesFilter: minFilter,
            ampm: "",
            class: "flex xs5 sm5 lg5"
          }, null, 8, ["modelValue"]), [
            [_vShow, _unref(pickTime)]
          ])
        ])
      ])
    ]),
    (_unref(newGroup))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_va_button, {
            icon: "save",
            onClick: saveNew,
            color: "primary",
            disabled: !_unref(valid)
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (__props.showSubscriptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h2", { onClick: toggleSubList }, [
                  _hoisted_11,
                  _createVNode(_component_VaIcon, { name: _unref(subListIconName) }, null, 8, ["name"])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_va_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(draggable), {
                        modelValue: subscriptions.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((subscriptions).value = $event)),
                        group: "subscriptions",
                        onStart: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drag = true)),
                        onEnd: _cache[8] || (_cache[8] = ($event: any) => (_ctx.drag = false)),
                        onChange: dragChange,
                        sort: false,
                        "item-key": "id"
                      }, {
                        item: _withCtx(({ element }) => [
                          _createVNode(SubscriptionListItem, {
                            subscription: element,
                            draggable: true
                          }, null, 8, ["subscription"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", null, "No Subscriptions", 512), [
                    [_vShow, subscriptions.value.length == 0]
                  ])
                ], 512), [
                  [_vShow, subListVisible.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})